import {React, ObservableValue, DomeComponent} from '@lexriver/dome'
import css from './Form.m.scss'

interface Attrs{
    header?:string
    maxWidth?:string
    disabledO?:ObservableValue<boolean>
}

export class Form extends DomeComponent<Attrs>{
    protected refFieldset!:HTMLFieldSetElement
    render(){
        //console.log('Form render()')
        return (
            <div class={css.form} style={{maxWidth:this.attrs.maxWidth}}>
                {this.attrs.header && 
                <div class={css.formHeader}>
                    <h1>{this.attrs.header}</h1>
                </div>
                }
                <fieldset  class={css.invisible} disabled={this.attrs.disabledO && this.attrs.disabledO.get()} ref={ref => this.refFieldset = ref}>
                    {this.children}
                </fieldset>
            </div>            
        )
    }

    async updateAsync(){
        this.refFieldset.disabled = this.attrs.disabledO?.get() ? true : false
    }

    disable(){
        this.refFieldset.disabled = true
    }

    enable(){
        this.refFieldset.disabled = false
    }
}